export default __webpack_public_path__ + "static/media/stitching_frame_black.712fd0df.svg";